module.exports = __webpack_public_path__ + "img/movienight_back.8a4bb260.jpg";